import {Col, Row} from "react-bootstrap";
import React from "react";
import {trans} from "../../../../../../translations/translations";

const FatigueAdvice5 = () => {
    return (
        <Row className={"response-row"}>
            <Col xs={12} className={"title mb-2"}>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer3.fatigue.advice5.title.text1', 'sos')}</span>
                    <span className={"me-1 text-pink text-bold"}>{trans('results.answer3.fatigue.advice5.title.text2', 'sos')}</span>
                    <span className={"me-1"}>{trans('results.answer3.fatigue.advice5.title.text3', 'sos')}</span>
                    <span className={"me-1 text-pink text-bold"}>{trans('results.answer3.fatigue.advice5.title.text4', 'sos')}</span>
                </p>
            </Col>
            <Col xs={12} className={"text-result mb-3"}>
                <p className={"m-0"}>{trans('results.answer3.fatigue.advice5.sub.text1', 'sos')}</p>
                <p className={"m-0"}>{trans('results.answer3.fatigue.advice5.sub.text2', 'sos')}</p>
            </Col>
            <Col xs={12} className={"text-result mb-3"}>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer3.fatigue.advice5.sub.text3', 'sos')}</span>
                    <span>{trans('results.answer3.fatigue.advice5.sub.text4', 'sos')}</span>
                </p>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer3.fatigue.advice5.sub.text5', 'sos')}</span>
                    <span>{trans('results.answer3.fatigue.advice5.sub.text6', 'sos')}</span>
                </p>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer3.fatigue.advice5.sub.text7', 'sos')}20h :</span>
                    <span>{trans('results.answer3.fatigue.advice5.sub.text8', 'sos')}</span>
                </p>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer3.fatigue.advice5.sub.text9', 'sos')}</span>
                    <span>{trans('results.answer3.fatigue.advice5.sub.text10', 'sos')}</span>
                </p>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer3.fatigue.advice5.sub.text11', 'sos')}</span>
                    <span>{trans('results.answer3.fatigue.advice5.sub.text12', 'sos')}</span>
                </p>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer3.fatigue.advice5.sub.text13', 'sos')}</span>
                    <span>{trans('results.answer3.fatigue.advice5.sub.text14', 'sos')}</span>
                </p>
            </Col>
            <Col xs={12} className={"text-result mb-3"}>
                <p className={"m-0"}>{trans('results.answer3.fatigue.advice5.sub.text15', 'sos')}</p>
            </Col>
        </Row>
    )
}

export default FatigueAdvice5;
